import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { StringAnyMap } from 'src/app/core/models/common.models';
import { InnerStatusesStoreService } from 'src/app/core/store/services/inner-statuses-store.service';
import { BaseSingleSelectComponent } from '../craft-single-select/craft-single-select.component';

@Component({
  selector: 'craft-inner-statuses-select',
  templateUrl: './craft-inner-statuses-select.component.html',
  styleUrls: ['./craft-inner-statuses-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CraftInnerStatusesSelectComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CraftInnerStatusesSelectComponent extends BaseSingleSelectComponent implements OnInit, OnChanges {
  @Input() public items: Readonly<StringAnyMap>;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    private innerStatusesStore: InnerStatusesStoreService,
  ) {
    super(changeDetectorRef);
    this.idFieldName = 'id';
    this.labelFieldName = 'name';
  }

  public ngOnInit() {
    super.ngOnInit();
    this.innerStatusesStore.map$.pipe(takeUntil(this.destroy$)).subscribe((statuses) => {
      this.setItems(statuses, this.selectedId);
    });
  }
}
